module.exports = __webpack_public_path__ + "static/media/tao2.d1fe7e86.png";